<template>
  <div class="footer_container">
      <div class="footer_navigation">
          <div @dblclick="openAdminPanel" class="logo">
              <h1 class="logo_big">AGMAR.</h1>
              <a class="logo_small">meble kuchenne</a>
          </div>
          <p class="author">Created by shizz0@outlook.com</p>
      </div>
      <router-link class="credits" to="/credits">Grafika na stronie</router-link>
  </div>
</template>

<script>
export default {
    name: 'Footer',
    methods:{
        openAdminPanel(){
           this.$router.push('/admin')
        }
    }
}
</script>

<style scoped lang="scss">
.footer_container{
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px 0;
    position: relative;
}
.logo{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}
.logo_big, .logo_small{
    color: white;
}
.logo_big{
    font-size: 28px;
    line-height: 20px;
}
.logo_small{
    font-size: 14px;
}
.footer_container{
    background: #1a1a1a;
}
.author{
    color: white;
    font-size: 12px;
    margin: 12px 0 6px 0;
}
.credits{
    position: absolute;
    left: 10px;
    bottom: 10px;
    color: #313131;
    text-decoration: none;
}
</style>